import React, { MouseEventHandler } from 'react'
import styles from './styles.module.scss'
import clsx from 'clsx'
import { Spinner } from '../../../components'

type JourneeButtonProps = {
    onClick?: MouseEventHandler
    selected?: boolean
    loading?: boolean
    children?: React.ReactNode
}
export const JourneeButton = ({ onClick, selected, loading, children }: JourneeButtonProps) => (
    <button
        onClick={onClick}
        className={clsx(styles.button, selected && styles.selected, loading && styles.loading)}
    >
        <Spinner className={styles.spinner} />
        {children}
    </button>
)
